import {
  type AvailableTimezoneResponse,
  TimezoneRestControllerService,
} from '@api'

async function getAvailableTimezones(): Promise<AvailableTimezoneResponse> {
  return TimezoneRestControllerService.getAvailableTimezones()
}

async function setTimezone(timezone: string) {
  return TimezoneRestControllerService.updateTimezone({
    requestBody: { timezone },
  })
}

export const timezoneService = {
  getAvailableTimezones,
  setTimezone,
}
